import React, { useEffect, useRef } from 'react';
import {
  ScheduleGetAvailabilityQueryDto,
  ScheduleGetAvailabilityRequestDto,
  ScheduleGetAvailabilityResponseDto,
} from '../types/schedule';
import APIService from '../index.api';

export function useScheduleAvailability(
  body: ScheduleGetAvailabilityRequestDto,
  query: ScheduleGetAvailabilityQueryDto,
  options?: {
    onFirstTimeLoad?: (res: ScheduleGetAvailabilityResponseDto | null) => void;
    onLoad?: (
      res: ScheduleGetAvailabilityResponseDto | null,
      firstTime: boolean,
    ) => void;
  },
  cachePrevious = false,
) {
  const firstTimeLoaded = useRef(false);
  const [ready, setReady] = React.useState(false);
  const [data, setData] =
    React.useState<ScheduleGetAvailabilityResponseDto | null>(null);

  useEffect(() => {
    async function fetch() {
      try {
        if (!data) {
          setReady(false);
        }
        if (
          cachePrevious &&
          data?.availability &&
          body.offset < data.availability.length
        ) {
          setReady(true);
          return;
        }
        const res = await APIService.scheduleService.getAvailability(
          body,
          query,
        );
        if (res?.availability) {
          const newRes: ScheduleGetAvailabilityResponseDto = res;
          if (!cachePrevious) {
            setData(newRes);
          } else {
            setData({
              ...newRes,
              availability: [
                ...(data?.availability || []),
                ...newRes.availability,
              ],
            });
          }

          if (options?.onLoad) {
            options?.onLoad(newRes, !firstTimeLoaded.current);
          }

          if (!firstTimeLoaded.current) {
            firstTimeLoaded.current = true;
            if (options?.onFirstTimeLoad) {
              options?.onFirstTimeLoad(newRes);
            }
          }
        } else {
          setData(null);
        }
      } catch (e) {
        setData(null);
      } finally {
        setReady(true);
      }
    }
    fetch();
  }, [body, query]);

  return { ready, data };
}
